// Minimal Stripe client stub for builds that expect this module.
// Return null so UI falls back to server-provided checkout_url redirects.

export type StripeLike = {
  redirectToCheckout: (opts: { sessionId: string }) => Promise<{ error?: any }>
} | null;

export async function getStripeClient(): Promise<StripeLike> {
  return null;
}

